import {Persoana} from "../basic-info/basic.patient.info.types";

export enum AcordPacientInformatFieldNames{
    API_SB_V2__info1_4 = "API_SB_V2__info1_4",
    API_SB_V2__info2_4 = "API_SB_V2__info2_4",
    API_SB_V2__info3_4 = "API_SB_V2__info3_4",
    API_SB_V2__info4_4 = "API_SB_V2__info4_4",
    API_SB_V2__info5_4 = "API_SB_V2__info5_4",
    API_SB_V2__info6_4 = "API_SB_V2__info6_4",
    API_SB_V2__info6extra_4 = "API_SB_V2__info6extra_4",
    API_SB_V2__info7_4 = "API_SB_V2__info7_4",
    API_SB_V2__info7extra_4 = "API_SB_V2__info7extra_4",
    API_SB_V2__info8_4 = "API_SB_V2__info8_4",
    API_SB_V2__info8extra_4 = "API_SB_V2__info8extra_4",
    API_SB_V2__info9_4 = "API_SB_V2__info9_4",
    API_SB_V2__info10_4 = "API_SB_V2__info10_4",
    API_SB_V2__info11_4 = "API_SB_V2__info11_4",
    API_SB_V2__info1_5 = "API_SB_V2__info1_5",
    API_SB_V2__info1_6 = "API_SB_V2__info1_6",
    API_SB_V2__info2_6 = "API_SB_V2__info2_6",
    API_SB_V2__info3_6 = "API_SB_V2__info3_6",
    API_SB_V2__info4_6 = "API_SB_V2__info4_6",
    API_SB_V2__info1_7 = "API_SB_V2__info1_7",
    API_SB_V2__info1_8 = "API_SB_V2__info1_8",
    // API_SB_V2__info2_8 = "API_SB_V2__info2_8",
    // API_SB_V2__info3_8 = "API_SB_V2__info3_8",
    // API_SB_V2__info4_8 = "API_SB_V2__info4_8",
    // API_SB_V2__info5_8 = "API_SB_V2__info5_8",
    // API_SB_V2__info6_8 = "API_SB_V2__info6_8",
    // API_SB_V2__info7_8 = "API_SB_V2__info7_8",
    // API_SB_V2__info8_8 = "API_SB_V2__info8_8",
    // API_SB_V2__info9_8 = "API_SB_V2__info9_8",
    // API_SB_V2__info10_8 = "API_SB_V2__info10_8",
    // API_SB_V2__info11_8 = "API_SB_V2__info11_8",
    API_SB_V2__info1_9 = "API_SB_V2__info1_9",
    API_SB_V2__acord = "API_SB_V2__acord"
}

export const questions_acord_informat_sib_v2 = [
    {   id: '4',
        title: "Au fost furnizate pacientului următoarele informații în legătura cu actul medical:",
        ques: [
            {id: "info1", q: "Date despre starea de sănătate", extra: false},
            {id: "info2", q: "Diagnostic", extra: false},
            {id: "info3", q: "Prognostic", extra: false},
            {id: "info4", q: "Natura și scopul actului medical propus", extra: false},
            {id: "info5", q: "Natura și scopul actului medical propus", extra: false},
            {
                id: "info6",
                q: "Beneficiile și consecințele actului medical, insistându-se asupra următoarelor:",
                extra: true
            },
            {id: "info7", q: "Riscurile potențiale ale actului medical, insistându-se asupra următoarelor:", extra: true},
            {
                id: "info8",
                q: "Alternative viabile de tratament și riscurile acestora, insistându-se asupra următoarelor:",
                extra: true
            },
            {id: "info9", q: "Riscurile neefectuării tratamentului", extra: false},
            {id: "info10", q: "Riscurile nerespectării recomandărilor medicale", extra: false},
            {id: "info11", q: "Prețul de cost estimativ al actului medical", extra: false},
        ]
    },
    {   id: '5',
        title: "Consimțământ pentru recoltare",
        ques: [
            { id: "info1",  q: "Pacientul este de acord cu recoltarea, păstrarea și folosirea produselor biologice, natura și scopul acestora fiind explicate pe înțelesul său:", extra:false},
        ]
    },

    {   id: '6',
        title: "Alte informații care au fost furnizate pacientului",
        ques: [
            { id: "info1",  q: "Informații despre serviciile medicale disponibile", extra:false},
            { id: "info2",  q: "Informații despre identitatea și statutul profesional al personalului care îl va trata*" +
                    "*Identificat în tabelul cu personalul medical care acordă îngrijiri de sănătate pacientului", extra:false},
            { id: "info3",  q: " Informații despre regulile/practicile din unitatea medicală, pe care trebuie să le respecte", extra:false},
            { id: "info4",  q: "Pacientul a fost încunoștințat că are dreptul la o a doua opinie medicală", extra:false},
        ]
    },

    {   id: '7',
        title: "Informare",
        ques: [
            { id: "info1",  q: "Pacientul dorește să fie informat în continuare despre starea sa de sănătate", extra:false},
        ]
    },

    {   id: '8',
        title: "Consimțământ pentru efectuarea următoarelor investigații paraclinice.",
        ques: [
            { id: "info1",  q: "{REPLACE}", extra:false},
            //{ id: "info1",  q: "Radiografie panoramică - pentru evaluarea generală a arcadelor dentare, sinusurilor maxilare și articulațiilor temporo-mandibulare.", extra:false},
            // { id: "info2",  q: "Radiografie retroalveolară - pentru detalii mai precise ale unor dinți individuali.", extra:false},
            // { id: "info3",  q: "Radiografie bite-wing - utilă pentru identificarea cariilor interdentare și evaluarea densității osoase.", extra:false},
            //
            // { id: "info4",  q: "Test microbiologic - pentru detectarea bacteriilor implicate în afecțiuni precum parodontita sau abcesele dentare.", extra:false},
            // { id: "info5",  q: "Cultura fungică - mai ales în cazurile de stomatită candidală.", extra:false},
            // { id: "info6",  q: "Testare la alergii - pentru pacienții care pot avea reacții alergice la materiale dentare sau medicamente.", extra:false},
            // { id: "info7",  q: "Analize de sânge: Hemoleucogramă completă (pentru a detecta eventualele infecții sau anemii). Glicemie (pentru a verifica riscul de diabet, care poate afecta sănătatea orală).", extra:false},
            //
            // { id: "info8",  q: "Tomografie computerizată (CBCT) - pentru o evaluare tridimensională detaliată a structurilor maxilo-faciale.", extra:false},
            // { id: "info9",  q: "Fotografia intraorală - pentru documentare și comunicare cu pacientul.", extra:false},
            // { id: "info10",  q: "Test genetic - pentru identificarea predispoziției la afecțiuni dentare, cum ar fi boala parodontală.", extra:false},
            // { id: "info11",  q: "Orice alta investigatie.", extra:false},
        ]
    },

    {   id: '9',
        title: "Discernământul",
        ques: [
            { id: "info1",  q: " Suferiți de afecțiuni care vă afectează discernământul ?", extra:false},
        ]
    },
]

export class StaffPerson{
    numeSiPrenume: string;
    profesie: string;
    gradSpecialitate: string;
}


export const AcordPacientInformatsCSS:string = `

`
